import { SSOAttributeMapping } from '@/types/registration.types';
import { v4 as uuid } from 'uuid';
export type TempRegField = { field: string | number; value: string; id: string };

export const filterOutValidFields = (tempField: TempRegField) => !(tempField.field && tempField.value.trim());
export const fieldObjectToFieldId = (tempField: TempRegField) => tempField.field.toString();
export const fieldsToArray = (
  fields: Record<string, string>,
  defaultField: string,
  existingQuestions?: boolean
): TempRegField[] => {
  if (Object.keys(fields).length) {
    return Object.entries(fields).map(([key, value]) => ({
      field: existingQuestions ? Number(key) : key,
      value,
      id: uuid(),
    }));
  } else {
    return [{ field: defaultField, value: '', id: uuid() }];
  }
};
export const getDuplicates = (regFieldsTemp: TempRegField[]) => {
  const countMap: Map<string, number> = new Map();
  const setIds = regFieldsTemp.map((tempField) => String(tempField.field));
  setIds.forEach((id) => countMap.set(id, (countMap.get(id) ?? 0) + 1));
  const duplicates: string[] = [];

  for (const [field, count] of countMap.entries()) {
    if (count > 1) {
      duplicates.push(field);
    }
  }

  return duplicates;
};

export const getRegistrationQuestionFields = (attrMapping: SSOAttributeMapping) => {
  return Object.entries(attrMapping).reduce(
    (acc, [key, val]) => {
      if (key && key.startsWith('reg_question.')) {
        const questionKey = key.split('.').pop();
        if (questionKey !== undefined) {
          acc[questionKey] = val;
        }
      }
      return acc;
    },
    {} as Record<string, string>
  );
};

export const getStandardAttrMapping = (attrMapping: SSOAttributeMapping) => {
  return Object.entries(attrMapping).reduce((acc, [key, val]) => {
    if (key && !key.startsWith('reg_question.')) {
      acc[key as keyof SSOAttributeMapping] = val;
    }
    return acc;
  }, {} as SSOAttributeMapping) as SSOAttributeMapping;
};
